



































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CollapseRowV2 from '@/componentsV2/molecules/CollapseRowV2/CollapseRowV2.vue';
import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import ProgramStatusTag from '@/componentsV2/atoms/ProgramStatusTag/ProgramStatusTag.vue';
import ArrowDownIcon from '@/components/icons/Arrow.vue';
import { EProgramStatusStatus, TProgramStatus } from '@/models/program-status';
import { upperCaseFirstLetter } from '@/utils/string';
import { isOnlineProvider } from '@/utils/provider';
import { IBusinessType } from '@/models/business';

@Component({
  components: {
    Typography,
    CollapseRowV2,
    FilterTag,
    ArrowDownIcon,
    ProgramStatusTag
  }
})
export default class ProgramStatusItem extends Vue {
  @Prop() rewardProgram!: TProgramStatus;
  @Prop() rewardsActive!: TProgramStatus;

  EProgramStatusStatus = EProgramStatusStatus;

  collapsed = false;

  get cards() {
    if (!this.rewardProgram.cards) return [];
    return this.rewardProgram.cards;
  }

  get tPrefix() {
    return 'programStatus';
  }

  get atLeastOneCardFailed() {
    return this.cards.some(
      item => item.status === 'failed' || (item.status as any) === 'inactive'
    );
  }

  get disclaimerType() {
    if (this.atLeastOneCardFailed) return 'failed';
    if (isOnlineProvider(this.rewardProgram.provider))
      return IBusinessType.ONLINE;

    return IBusinessType.INSTORE;
  }

  get provider() {
    return upperCaseFirstLetter(this.rewardProgram.provider);
  }

  get showDisclaimer() {
    return this.atLeastOneCardFailed || !this.rewardProgram.cards;
  }

  @Watch('rewardsActive')
  changedRewardsActive() {
    if (this.collapsed && !this.rewardsActive) {
      this.collapsed = false;
    }
  }

  retryIntegration() {
    this.$router.push('/settings/apps');
  }

  clickCollapse() {
    if (!this.rewardsActive) return;
    this.collapsed = !this.collapsed;
  }
}
